export const CTA_LIST = {
  OPEN_MODAL: 'OPEN_MODAL',
  EDIT_LOCATION: 'EDIT_LOCATION',
  GPS_CTA: 'GPS_CTA',
  BACK_TO_RADIUS: 'BACK_TO_RADIUS',
};
